import { DASHBOARD } from "../../../helper/url_helper";
import { axiosApi } from "../../../services/api";

import { createAsyncThunk } from "@reduxjs/toolkit";
export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosApi.get(DASHBOARD);
      return res.data.data;
    } catch (err) {
      return rejectWithValue({
        message: err?.response?.data?.message,
        statusCode: err?.response?.status || 500,
      });
    }
  },
);
